import * as React from 'react';
import { IPaginatedLandingContent, PillColor, LayoutStyle } from '../models/paginated-landing-content'
import { LandingPageContent } from './landing-page-content';
import { HorizontalCardContent } from './horizontal-card-content';

interface IProps {
    items: IPaginatedLandingContent[];
    layoutStyle: LayoutStyle;
    currentPage: number;
    pageSize: number;
    searchText: string;
    fallbackImageUrl: string;
    showFallbackImage: boolean;
    topicPillColor: PillColor;
    rolePillColor: PillColor;
    ageRangePillColor: PillColor;
    contentTypePillColor: PillColor;
    specialtyPillColor: PillColor;
}

export class ContentList extends React.Component<IProps, any> {

    render() {
        const {
            items,
            currentPage,
            pageSize,
            searchText,
            topicPillColor,
            rolePillColor,
            ageRangePillColor,
            contentTypePillColor,
            specialtyPillColor
        } = this.props;

        let currentMinimum = (currentPage - 1) * pageSize;
        let currentMaximum = currentPage * pageSize;

        let paginatedItems = items.slice(currentMinimum, currentMaximum) as IPaginatedLandingContent[];

        return (
            <React.Fragment>
                {this.renderItems(paginatedItems, topicPillColor, rolePillColor, ageRangePillColor, contentTypePillColor, specialtyPillColor)}
            </React.Fragment>
        );
    }

    renderItems = (
        paginatedItems: IPaginatedLandingContent[],
        topicPillColor: PillColor,
        rolePillColor: PillColor,
        ageRangePillColor: PillColor,
        contentTypePillColor: PillColor,
        specialtyPillColor: PillColor) => {
        const ContentItem = this.getLayoutComponent();

        return (
            <div className="paginated-template-inner">
                {paginatedItems.map((item, i) =>
                    <ContentItem
                        content={item}
                        fallbackImageUrl={this.props.fallbackImageUrl}
                        showFallbackImage={this.props.showFallbackImage}
                        key={i}
                        topicPillColor={topicPillColor}
                        rolePillColor={rolePillColor}
                        ageRangePillColor={ageRangePillColor}
                        contentTypePillColor={contentTypePillColor}
                        specialtyPillColor={specialtyPillColor} />)}
            </div>
        )
    }

    getLayoutComponent = () => {
        switch (this.props.layoutStyle) {
            case LayoutStyle.HorizontalCard:
                return HorizontalCardContent;
            case LayoutStyle.List:
                return LandingPageContent;
            default:
                return LandingPageContent;
        }
    }
}





